'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _doctifyWfMicroStar = require('./doctify-wf-micro-star');

var _doctifyWfMicroStar2 = _interopRequireDefault(_doctifyWfMicroStar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = typeof navigator !== 'undefined' && navigator.languages || ['en'],
    locale = _ref[0];
// import '../../src/styles/style.scss';


var _locale$split = locale.split('-'),
    localeBase = _locale$split[0];

var lang = require('react-intl/locale-data/' + localeBase);
var messages = void 0;
try {
    messages = require('./../../src/lang/' + localeBase + '.json');
} catch (error) {
    messages = require('./../../src/lang/en.json');
}
(0, _reactIntl.addLocaleData)(lang);

var WfMicroStarWidget = function WfMicroStarWidget(props) {
    var href = props.link || props.profileId && props.profileType && props.baseUrl + '/' + props.profileType.slice(0, -1) + '/' + props.profileId;
    return _react2.default.createElement(
        _reactIntl.IntlProvider,
        { locale: localeBase, messages: messages },
        _react2.default.createElement(_doctifyWfMicroStar2.default, (0, _extends3.default)({}, props, { href: href }))
    );
};

WfMicroStarWidget.displayName = 'WfMicroStarWidget';

WfMicroStarWidget.defaultProps = {};

var mapStateToProps = function mapStateToProps(_ref2) {
    var wfMicroStar = _ref2.wfMicroStar;

    return {
        averageRating: +wfMicroStar.widget.average_rating,
        totalReviews: wfMicroStar.widget.total_reviews,
        profileType: wfMicroStar.widget.profileType,
        profileId: wfMicroStar.widget.profileId,
        baseUrl: wfMicroStar.widget.baseUrl,
        link: wfMicroStar.widget.link,
        layoutType: wfMicroStar.widget.layoutType,
        layoutOrientation: wfMicroStar.widget.layoutOrientation,
        responsiveId: wfMicroStar.widget.responsiveId,
        bodyStyle: wfMicroStar.widget.bodyStyle,
        blackAndWhiteTheme: wfMicroStar.widget.blackAndWhiteTheme,
        wrapperFrame: wfMicroStar.widget.wrapperFrame,
        isShrinked: wfMicroStar.widget.isShrinked
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(WfMicroStarWidget);